import { render, staticRenderFns } from "./proposal-prioritization.vue?vue&type=template&id=6a7de32e&"
import script from "./proposal-prioritization.vue?vue&type=script&lang=ts&"
export * from "./proposal-prioritization.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports